module.exports = __webpack_public_path__ + "static/media/thumbnail.9aaf06b2.jpg";